import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getStatusStateSelectors } from '../../../helpers/store/state-with-status';

import {
  TrackingPageNumbersState,
  adapter
} from './tracking-page-numbers.reducer';

const { selectIsStatusLoadingState } = getStatusStateSelectors();

const { selectAll } = adapter.getSelectors();

const selectTrackingNumbersStateSelector =
  createFeatureSelector<TrackingPageNumbersState>('trackingPageNumbers');

const selectOpenedSidebarItemsState = (state: TrackingPageNumbersState) =>
  state.openedSidebarItems;
export const selectOpenedSidebarItems = createSelector(
  selectTrackingNumbersStateSelector,
  selectOpenedSidebarItemsState
);

export const selectLoading = createSelector(
  selectTrackingNumbersStateSelector,
  selectIsStatusLoadingState
);

const selectSidebarItemsStateSelector = (state: TrackingPageNumbersState) =>
  state.sidebarItems;

const selectSidebarItemsState = createSelector(
  selectAll,
  selectSidebarItemsStateSelector,
  (items, sidebarItems) => sidebarItems.map(({ id, ...item }) => ({
      ...item,
      id,
      items: items.filter(({ trackingNumbers }) =>
        trackingNumbers.filter(({ sidebarItemId }) =>
          sidebarItemId != null
            ? sidebarItemId.toString() === id
            : sidebarItemId === id
        )
      )
    }))
);
export const selectSidebarItems = createSelector(
  selectTrackingNumbersStateSelector,
  selectSidebarItemsState
);

const selectAllItemsState = (items) => items;

export const isLoadMoreVisibleState = (
  state: TrackingPageNumbersState
): boolean => state.sidebarItems.length < state.totalSidebarItems;

export const isLoadMoreTrackingNumbersVisibleState = (
  state: TrackingPageNumbersState
): boolean => state.ids.length < state.totalItems;

export const isLoadMoreTrackingNumbersVisible = createSelector(
  selectTrackingNumbersStateSelector,
  isLoadMoreTrackingNumbersVisibleState
);

export const selectIsLoadMoreVisible = createSelector(
  selectTrackingNumbersStateSelector,
  isLoadMoreVisibleState
);

export const showMoreValues = (state: TrackingPageNumbersState): number => state.totalSidebarItems - state.sidebarItems.length;

export const selectShowMoreValues = createSelector(
  selectTrackingNumbersStateSelector,
  showMoreValues
);

export const selectMoreTrackingNumberValuesState = (
  state: TrackingPageNumbersState
): number => state.totalItems - state.ids.length;

export const selectMoreTrackingNumberValues = createSelector(
  selectTrackingNumbersStateSelector,
  selectMoreTrackingNumberValuesState
);

const selectTrackingPageNumbersWithSidebar = createSelector(
  selectAll,
  selectSidebarItemsState,
  selectOpenedSidebarItemsState,
  (items, sidebarItems, openedItems) => {
    if (sidebarItems.length) {
      return selectAllItemsState(
        items.filter(({ trackingNumbers }) =>
          trackingNumbers.filter(({ sidebarItemId }) =>
            openedItems.includes(
              sidebarItemId != null ? sidebarItemId.toString() : sidebarItemId
            )
          )
        )
      );
    } else {
      return selectAllItemsState(items);
    }
  }
);

const selectTrackingPageNumbersState = createSelector(
  selectAll,
  selectAllItemsState
);

export const selectTrackingPageNumbers = createSelector(
  selectTrackingNumbersStateSelector,
  selectTrackingPageNumbersWithSidebar
);

const selectFirstTrackingPageNumberState = createSelector(
  selectTrackingPageNumbersState,
  (trackingPageNumbers) => trackingPageNumbers[0]
);

export const selectFirstTrackingPageNumber = createSelector(
  selectTrackingNumbersStateSelector,
  selectFirstTrackingPageNumberState
);

const selectShowDetailsState = (state: TrackingPageNumbersState) =>
  state.showDetails;

const selectShowDetailsLoadingState = (state: TrackingPageNumbersState) =>
  state.showDetailsLoading;

export const selectShowDetails = createSelector(
  selectTrackingNumbersStateSelector,
  selectShowDetailsState
);

export const selectShowDetailsLoading = createSelector(
  selectTrackingNumbersStateSelector,
  selectShowDetailsLoadingState
);

const selectSelectedTrackingNumberState = (state: TrackingPageNumbersState) =>
  state.selectedTrackingNumber;

export const selectSelectedTrackingNumber = createSelector(
  selectTrackingNumbersStateSelector,
  selectSelectedTrackingNumberState
);

const selectCheckpointsState = (state: TrackingPageNumbersState) =>
  state.trackingNumberCheckpoints;

export const selectCheckpoints = createSelector(
  selectTrackingNumbersStateSelector,
  selectCheckpointsState
);
